import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { Permissions } from '../../models/permissions';
import { Action } from '../../models/action.interface';
import { ACTION_CODES } from '../../enums/action-codes.enum';
import { ACTION_GROUP_CODES } from '../../enums/action-group-codes.enum';
import { constants } from '../../constants/constants';

@Injectable({ providedIn: 'root' })
export class StoragePermissionService {
	static getDocumentManagementPermissions(): Permissions {
		return LocalStorageService.getItem(
			constants.localStorageKeys.PERMISSIONS_USER
		)
			.filter(
				(action) => action.groupCode === ACTION_GROUP_CODES.DOCUMENT_MANAGEMENT
			)
			.reduce((accumulator, currentAction: Action) => {
				accumulator[ACTION_CODES[currentAction.code]] = true;

				return accumulator;
			}, {});
	}

	static getAllUserPermissions(): Permissions {
		return LocalStorageService.getItem(
			constants.localStorageKeys.PERMISSIONS_USER
		)?.reduce((accumulator: Permissions, currentAction: Action) => {
			accumulator[ACTION_CODES[currentAction.code]] = true;

			return accumulator;
		}, {});
	}

	static getRulePermissions(): Permissions {
		return LocalStorageService.getItem(
			constants.localStorageKeys.PERMISSIONS_USER
		)
			.filter((action) => action.groupCode === ACTION_GROUP_CODES.RULES)
			.reduce((accumulator, currentAction: Action) => {
				accumulator[ACTION_CODES[currentAction.code]] = true;

				return accumulator;
			}, {});
	}
}
